export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14224.9d68989d.jpg";